if (!window.customElements.get('frequently-buy')) {
  class FrequentlyBuy extends HTMLElement {
    connectedCallback() {
      this._button = this.querySelector('[data-fbt-add]');
      if (!this._button) return;

      this._contentEl = this._button.querySelector('.fbt__cta-content');
      this._loaderEl  = this._button.querySelector('.fbt__cta-loader');

      this._onClick = this._onClick.bind(this);
      this._button.addEventListener('click', this._onClick);

      const formId = this.getAttribute('form-id');
      if (formId) {
        this._form = document.getElementById(formId);
        if (this._form) {
          this._onVariantChange = this._onVariantChange.bind(this);
          this._form.addEventListener('variant:change', this._onVariantChange);
        }
      }
    }

    disconnectedCallback() {
      this._button?.removeEventListener('click', this._onClick);
      this._form?.removeEventListener('variant:change', this._onVariantChange);
    }

    _startLoading() {
      if (!this._contentEl || !this._loaderEl) return;
      this._loadingPromise = null;

      const contentAnim = this._contentEl.animate(
        { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-10px)'] },
        { duration: 75, easing: 'ease', fill: 'forwards' }
      );

      this._loaderEl.hidden = false;
      const loaderAnim = this._loaderEl.animate(
        { opacity: [0, 1], transform: ['translate(-50%, 0%)', 'translate(-50%, -50%)'] },
        { duration: 75, delay: 75, easing: 'ease', fill: 'forwards' }
      );

      this._loadingPromise = Promise.all([
        new Promise((resolve) => { contentAnim.onfinish = () => resolve(); }),
        new Promise((resolve) => { loaderAnim.onfinish = () => resolve(); })
      ]);
    }

    async _stopLoading() {
      if (!this._contentEl || !this._loaderEl) return;
      if (!this._loadingPromise) return;
      await this._loadingPromise;

      const loaderAnim = this._loaderEl.animate(
        { opacity: [1, 0], transform: ['translate(-50%, -50%)', 'translate(-50%, -100%)'] },
        { duration: 75, delay: 100, easing: 'ease', fill: 'forwards' }
      );
      loaderAnim.onfinish = () => { this._loaderEl.hidden = true; };

      this._contentEl.animate(
        { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
        { duration: 75, delay: 175, easing: 'ease', fill: 'forwards' }
      );

      this._loadingPromise = null;
    }

    _onVariantChange(event) {
      const variant = event.detail && event.detail.variant;

      if (!variant) return;

      this.setAttribute('data-current-variant-id', variant.id);

      // Get knob images of selected variant
      const json = document.getElementById(`knob-images-${variant.id}`);
      if (!json) return;

      const images = JSON.parse(json.textContent);

      console.log(images); // Check in browser console
    }

    async _onClick() {
      if (this._busy) return;

      const currentId = this.getAttribute('data-current-variant-id');
      const upsellId  = this.getAttribute('data-upsell-variant-id');
      if (!currentId || !upsellId) return;

      this._busy = true;
      this._button.setAttribute('aria-busy', 'true');
      this._button.disabled = true;
      this._startLoading();

      try {
        const routes = (window.themeVariables && window.themeVariables.routes) || {};
        const cartAddUrl = routes.cartAddUrl || '/cart/add';
        const cartUrl    = routes.cartUrl    || '/cart';

        const response = await fetch(`${cartAddUrl}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [
              { id: currentId, quantity: 1 },
              { id: upsellId,  quantity: 1 }
            ],
            sections: ['mini-cart']
          })
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || 'Failed to add bundle to cart');
        }

        // GA4 add_to_cart event tagged with source so FBT adds can be segmented in reporting.
        try {
          const addedItems = data.items || (data.id ? [data] : []);
          if (window.dataLayer && addedItems.length) {
            const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: 'add_to_cart',
              add_source: 'frequently_bought_together',
              ecommerce: {
                currency: currency,
                value: addedItems.reduce((sum, item) => sum + (item.price * item.quantity), 0) / 100,
                items: addedItems.map((item) => ({
                  item_id: String(item.product_id),
                  item_name: item.product_title,
                  item_variant: item.variant_title,
                  price: item.price / 100,
                  quantity: item.quantity
                }))
              }
            });
          }
        } catch (gaErr) {
          console.error('[frequently-buy] GA4 push failed', gaErr);
        }

        this.dispatchEvent(new CustomEvent('variant:added', {
          bubbles: true,
          detail: { variant: data.items ? data.items[0] : data }
        }));

        const cartResponse = await fetch(`${cartUrl}.js`);
        const cart = await cartResponse.json();
        cart.sections = data.sections;

        const settings = (window.themeVariables && window.themeVariables.settings) || {};
        const isPageCart = settings.cartType === 'page' || settings.pageType === 'cart';

        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart,
            openMiniCart: !isPageCart && settings.cartType === 'drawer'
          }
        }));
        this.dispatchEvent(new CustomEvent('cart-notification:show', {
          bubbles: true,
          cancelable: true,
          detail: { status: 'success' }
        }));

        if (isPageCart) {
          window.location.href = `${Shopify.routes.root}cart`;
        }
      } catch (err) {
        console.error('[frequently-buy]', err);
        this.dispatchEvent(new CustomEvent('cart-notification:show', {
          bubbles: true,
          cancelable: true,
          detail: { status: 'error', error: err.message }
        }));
      } finally {
        this._busy = false;
        this._button.disabled = false;
        this._button.removeAttribute('aria-busy');
        this._stopLoading();
      }
    }
  }

  window.customElements.define('frequently-buy', FrequentlyBuy);
}

class SanTrustMarquee extends HTMLElement {
  connectedCallback() {
    this._speed = parseFloat(this.dataset.speed) || 35;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Wait for images so width measurements are correct
    const imgs = Array.from(this.querySelectorAll('img'));
    Promise.all(
      imgs.map(img => img.complete ? Promise.resolve() : new Promise(res => {
        img.addEventListener('load', res, { once: true });
        img.addEventListener('error', res, { once: true });
      }))
    ).then(() => this._setup());
  }

  disconnectedCallback() {
    this._io?.disconnect();
    this._ro?.disconnect();
    clearTimeout(this._resizeTimer);
  }

  _setup() {
    if (!this.isConnected || !this.children.length || this._track) return;

    // Move items into an animated track
    this._track = document.createElement('div');
    this._track.className = 'san-trust-track';
    while (this.firstChild) this._track.appendChild(this.firstChild);
    this._originals = Array.from(this._track.children);
    this.appendChild(this._track);
    this.classList.add('is-marquee');

    this._measure();

    // Pause animation when off-screen
    this._io = new IntersectionObserver(([entry]) => {
      this.classList.toggle('is-offscreen', !entry.isIntersecting);
    }, { threshold: 0 });
    this._io.observe(this);

    // Touch pause (hover is handled in CSS)
    this.addEventListener('touchstart', () => this.classList.add('is-touched'), { passive: true });
    this.addEventListener('touchend', () => this.classList.remove('is-touched'), { passive: true });
    this.addEventListener('touchcancel', () => this.classList.remove('is-touched'), { passive: true });

    // Re-measure on container resize (debounced)
    let lastWidth = this.clientWidth;
    this._ro = new ResizeObserver(() => {
      if (this.clientWidth === lastWidth) return;
      lastWidth = this.clientWidth;
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this._measure(), 150);
    });
    this._ro.observe(this);
  }

  _measure() {
    const track = this._track;

    // Remove previous clones
    track.querySelectorAll('[data-clone]').forEach(n => n.remove());

    // Append one clone set to measure the exact loop distance (incl. gap)
    this._appendCloneSet();
    const loop = track.children[this._originals.length].offsetLeft - this._originals[0].offsetLeft;
    if (loop <= 0) return;

    // Track must cover loop + viewport so there is never an empty gap.
    // Total sets needed = ceil(viewport / loop) + 1; we already have 2.
    const setsNeeded = Math.ceil(this.clientWidth / loop) + 1;
    for (let i = 2; i < setsNeeded; i++) this._appendCloneSet();

    // Drive the CSS keyframe animation: distance + duration (constant px/s)
    this.style.setProperty('--san-marquee-loop', loop + 'px');
    this.style.setProperty('--san-marquee-duration', (loop / this._speed).toFixed(2) + 's');
  }

  _appendCloneSet() {
    this._originals.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-clone', '');
      this._track.appendChild(clone);
    });
  }
}

customElements.define('san-trust-marquee', SanTrustMarquee);

class SizeGuideTabs extends HTMLElement {
  connectedCallback() {
    this._onClick = this._onClick.bind(this);
    this.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
  }

  _onClick(event) {
    const button = event.target.closest('.size-guide__tab-button[data-tab-target]');
    if (!button || !this.contains(button)) return;

    const target = button.getAttribute('data-tab-target');

    this.querySelectorAll('.size-guide__tab-button[data-tab-target]').forEach((btn) => {
      const isActive = btn === button;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      panel.classList.toggle('is-hidden', panel.getAttribute('data-tab-panel') !== target);
    });
  }
}
customElements.define('size-guide-tabs', SizeGuideTabs);

if (!window.customElements.get('offer-price')) {
  class OfferPrice extends HTMLElement {
    connectedCallback() {
      this._toggle = this.querySelector('[data-offer-toggle]');
      this._dsc = this.querySelector('[data-offer-dsc]');
      this._code = this.querySelector('[data-offer-code]');
      this._copied = this.querySelector('[data-offer-copied]');

      this._onToggle = this._onToggle.bind(this);
      this._onCopy = this._onCopy.bind(this);
      this._onKeydown = this._onKeydown.bind(this);

      this._toggle?.addEventListener('click', this._onToggle);
      this._code?.addEventListener('click', this._onCopy);
      this._code?.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      this._toggle?.removeEventListener('click', this._onToggle);
      this._code?.removeEventListener('click', this._onCopy);
      this._code?.removeEventListener('keydown', this._onKeydown);
      clearTimeout(this._copiedTimer);
    }

    _onToggle() {
      if (!this._dsc || !this._toggle) return;
      this._dsc.removeAttribute('hidden');
      this._toggle.setAttribute('aria-expanded', 'true');
      this._toggle.setAttribute('hidden', '');
    }

    _onKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this._onCopy();
      }
    }

    _onCopy() {
      if (!this._code) return;
      const text = this._code.getAttribute('data-offer-code') || this._code.textContent.trim();

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => this._showCopied(), () => this._fallbackCopy(text));
      } else {
        this._fallbackCopy(text);
      }
    }

    _fallbackCopy(text) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* noop */ }
      document.body.removeChild(ta);
      this._showCopied();
    }

    _showCopied() {
      if (!this._copied) return;
      this._code?.setAttribute('hidden', '');
      this._copied.removeAttribute('hidden');
      clearTimeout(this._copiedTimer);
      this._copiedTimer = setTimeout(() => {
        this._copied.setAttribute('hidden', '');
        this._code?.removeAttribute('hidden');
      }, 1500);
    }
  }

  window.customElements.define('offer-price', OfferPrice);
}
